/** Fatti fissi del viaggio; i testi stanno nei locales, qui solo numeri e date. */
export type GeoPoint = { name: string; lat: number; lon: number }

export const DEPARTURE_DATE = '2026-10-10'

export const DESTINATION: GeoPoint = { name: 'Las Palmas de Gran Canaria', lat: 28.1235, lon: -15.4363 }

/** Orario del volo, ora italiana (CEST): il countdown arriva a zero qui. */
export const DEPARTURE_AT = Date.parse(`${DEPARTURE_DATE}T15:35:00+02:00`)

export type TimeLeft = { days: number; hours: number; minutes: number; seconds: number }

/** Tempo che manca a `target` (ms epoch) da `now`, in secondi interi; null quando è arrivato. */
export function timeLeft(target: number, now: number): TimeLeft | null {
  const total = Math.floor((target - now) / 1000)
  if (total <= 0) return null
  return {
    days: Math.floor(total / 86_400),
    hours: Math.floor(total / 3600) % 24,
    minutes: Math.floor(total / 60) % 60,
    seconds: total % 60,
  }
}

function dms(value: number, positive: string, negative: string): string {
  const abs = Math.abs(value)
  let degrees = Math.floor(abs)
  let minutes = Math.round((abs - degrees) * 60)
  if (minutes === 60) {
    degrees += 1
    minutes = 0
  }
  const hemisphere = value < 0 ? negative : positive
  return `${degrees}°${String(minutes).padStart(2, '0')}′${hemisphere}`
}

/** "28°07′N 15°26′W" */
export function formatCoords(point: { lat: number; lon: number }): string {
  return `${dms(point.lat, 'N', 'S')} ${dms(point.lon, 'E', 'W')}`
}
